import { Suspense } from "react";
import AnimatedSection from "./AnimationSection";

const HomeSection = ({ section }) => {
  const { Component, defer = true, animate = true, id } = section;

  let content = <Component />;
  if (id) content = <div id={id}>{content}</div>;
  if (animate) content = <AnimatedSection>{content}</AnimatedSection>;
  if (defer) content = <Suspense fallback={null}>{content}</Suspense>;

  return content;
};

export default HomeSection;
